import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";
import sl from "./sl.json";

Vue.use(VueI18n);

export const defaultLocale = "sl";

export const languages = {
  en,
  sl
};

const messages = Object.assign(languages);

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "sl",
  messages
});
